import React, { useEffect, useRef } from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

export interface ConnectorSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  matchCount: number;
}

export const ConnectorSearchInput: React.FC<ConnectorSearchInputProps> = ({
  value,
  onChange,
  matchCount,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const isCmdK = (e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k';
      if (isCmdK) {
        e.preventDefault();
        inputRef.current?.focus();
        inputRef.current?.select();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className="relative flex-1">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        ref={inputRef}
        type="search"
        placeholder="Search by name, platform, or description… (⌘K)"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            e.preventDefault();
            onChange('');
          }
        }}
        className="pl-10 pr-24"
        aria-label="Search connectors"
      />
      {value && (
        <span
          aria-live="polite"
          className="absolute right-3 top-1/2 -translate-y-1/2 text-xs px-2 py-0.5 rounded-full bg-muted text-muted-foreground"
        >
          {matchCount} {matchCount === 1 ? 'match' : 'matches'}
        </span>
      )}
    </div>
  );
};
